import React, {useEffect, useState} from "react";
import {
    Input,
    Button,
    Space,
    Card,
    Row,
    Col,
    message,
    Popconfirm,
    DatePicker
} from "antd";
import styles from "./ExternalApplication.module.css";

import {Pagination} from 'antd';

import {
    getExternalInfoListRequest
} from "../api";
import {closeAdminPage, openLogin} from "../../../../store/modalsSlice";
import settingIcon from "../setting.svg";
import {useDispatch} from "react-redux";
import ExternalAppInfoItem from "./ExternalAppInfoItem";
import dayjs from "dayjs";
import { clearAllCookies } from "../../../../util/handleObject";


const ExternalApplication = (props) => {

    const dispatch = useDispatch();
    const [keyword, setKeyword] = useState("");
    const [schoolList, setSchoolList] = useState([]);
    // 分页状态


    const [rangeTime,setRangeTime]=useState(['','']);
    const [totalNumber, setTotalNumber] = useState(0);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [messageApi, contextHolder] = message.useMessage();
    const {RangePicker} = DatePicker;

    useEffect(() => {
        getInfoList(keyword,rangeTime, (currentPage-1)*limit, limit)
    }, []); // 空数组意味着这个 effect 只会在组件挂载时执行一次

    function getInfoList(namekey,timeArray, offset, limit) {
        getExternalInfoListRequest(namekey,timeArray, offset, limit, (data) => {
            console.log(data);
            if (data.ret === '1') {
                setSchoolList(data.data.data)
                setTotalNumber(data.data.total_num)
            } else {
                setSchoolList([])
                setTotalNumber(0)
            }
        });
    }

    // 处理筛选提交
    const handleFilterSubmit = () => {
        setCurrentPage(1)
        getInfoList(keyword,rangeTime, 0, limit)

    };

    // 处理重置筛选
    const handleResetFilter = () => {
        setKeyword('')
        setRangeTime(['',''])
        setCurrentPage(1)
        // 重置后重新获取所有数据
    };

    const onShowSizeChange = (page, pageSize) => {
        //pageSize 变化的回调
        console.log(page, pageSize);
        setCurrentPage(1)
        setLimit(pageSize)
    };

    const onChangePage = (current, pageSize) => {
        //页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
        setCurrentPage(current)
        getInfoList(keyword,rangeTime, (current - 1) * pageSize, pageSize)

    };

    const dateFormat = 'YYYY-MM-DD HH:mm';
    const today = new Date();
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formatter = new Intl.DateTimeFormat('zh-CN', options);
    var maxDateString = formatter.format(today).replaceAll('/','-')+" 23:59";


    return (

        <div className={styles.background}>
            {contextHolder}
            <div className={styles.rightMenus}>
                <div className={styles["div-top"]}>
                    <h3 style={{marginLeft: 30}}>计费消耗管理</h3>

                    <Popconfirm
                        placement="bottom"
                        title={""}
                        description={"是否退出登录"}
                        okText="是"
                        cancelText="否"
                        onConfirm={(e) => {
                            sessionStorage.clear()
                            clearAllCookies()
                            dispatch(closeAdminPage())
                            dispatch(openLogin())
                        }}
                    >
                        <div className={styles.iconContainer}>
                            <img src={settingIcon} style={{width: '20px', height: '20px'}}/>
                        </div>
                    </Popconfirm>

                    <Button
                        className={styles["bt-refresh"]}
                        type="primary"
                        onClick={(e)=>{
                            getInfoList(keyword,rangeTime, (currentPage - 1) * limit, limit)
                        }}
                    >
                        刷新
                    </Button>
                </div>


                <Card
                      className={styles["card-top"]}
                      title={
                          <div className={styles.cardTab}>
                              <Button color="default" variant="outlined"
                                      style={{marginRight:"20px"}}
                                      onClick={() => {
                                          props.tabChange(0)
                                      }}
                              >内部应用</Button>
                              <Button type='primary'
                                      style={{marginLeft:"20px"}}
                                      onClick={() => {
                                          props.tabChange(1)
                                      }}
                              >外部应用</Button>
                          </div>
                      }
                >

                    <div className={styles["div-shaixuan"]}>
                        <div>数据筛选</div>

                        <Space className={styles["bt-shaixuan2"]}>
                            <Button onClick={handleResetFilter}>重置</Button>
                            <Button
                                type="primary"
                                onClick={handleFilterSubmit}
                            >
                                查询
                            </Button>

                        </Space>

                    </div>
                    <Row gutter={[20,20]} align="middle" style={{marginTop: 20}}>
                        <Col
                        >
                            <Row align="middle">
                                <Col flex="50px"
                                >
                                    关键字
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 50px)"}}
                                >
                                    <Input
                                        placeholder="关键字"
                                        value={keyword}
                                        onChange={(e) => {setKeyword(e.target.value)}}
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col>
                            <Row align="middle">
                                <Col flex="60px"
                                >
                                    操作时间
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 60px)"}}
                                >
                                    <RangePicker
                                        // locale={locale}
                                        // needConfirm = {true}
                                        // minDate={dayjs('2024-01-01', dateFormat)}
                                        minDate={dayjs('2024-01-01 00:00', dateFormat)}
                                        maxDate={dayjs(maxDateString, dateFormat)}
                                        showTime={{format: 'HH:mm'}}
                                        value={rangeTime[0].length > 0 ? [dayjs(rangeTime[0], dateFormat), dayjs(rangeTime[1], dateFormat)] : null}
                                        onChange={(date, dateString) => {
                                            setRangeTime(dateString)
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Col>


                    </Row>
                </Card>

                <Card title="" className={styles["card-bottom"]}>
                    <div className={styles["container-list"]}>

                        <div className={styles["div-shaixuan"]}>
                            <div>数据列表</div>

                            {/*<Button*/}
                            {/*    style={{marginLeft: 'auto'}}*/}
                            {/*    type="primary"*/}
                            {/*    onClick={() => {*/}
                            {/*        setIsModalVisible(true)*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*    添加*/}
                            {/*</Button>*/}

                        </div>


                        <div className={styles.tableContainer}>
                            <table className={styles.infoTable}>
                                <tr
                                    className={styles.tr1}
                                >
                                    <td
                                        className={styles.td1}
                                    >应用名称
                                    </td>
                                    {/*<td*/}
                                    {/*    className={styles.td2}*/}
                                    {/*>品牌/公司*/}
                                    {/*</td>*/}
                                    {/*<td*/}
                                    {/*    className={styles.td2}*/}
                                    {/*>应用类型*/}
                                    {/*</td>*/}
                                    <td
                                        className={styles.td2}
                                    >状态
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >点击统计
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >添加时间
                                    </td>
                                </tr>
                                {schoolList.map((item, index) => (
                                    <ExternalAppInfoItem
                                        item={item}
                                        key={index + 1}
                                        index={index + 1}
                                    />
                                ))}
                            </table>

                            {/* 分页控件 - 右下角 */}

                        </div>
                        <Pagination
                            hideOnSinglePage={false}//只有一页隐藏分页器
                            align="end"
                            style={{marginTop: 20}}
                            showSizeChanger //是否展示 pageSize 切换器，当 total 大于 50 时默认为 true
                            onShowSizeChange={onShowSizeChange}//pageSize 变化的回调
                            defaultCurrent={1}
                            current={currentPage}
                            total={totalNumber}
                            locale={{
                                items_per_page: '条/页',  // 将 "/page" 改为 "/页"
                            }}
                            pageSizeOptions={['10', '20', '30']} // 自定义选项值
                            pageSize={limit}
                            onChange={onChangePage}
                            showLessItems={false} // 关闭"简化显示"模式
                        />
                    </div>
                </Card>
            </div>


        </div>
    );
};

export default ExternalApplication;
